import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useId24 } from "../../../drivers/id24/Id24Provider";
import { LuckyDrawService } from "../services/lucky-draw.service";
import { Button, Card, Spin } from "antd";
import { loadAppConfig } from "../../../configs/app-config";

type TUserOfLucky = {
  id: number;
  listUsers: {
    fullName: string;
  };
};

export const PlayDraw: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState<boolean>(true);
  const [statusLucky, setStatusLucky] = useState<boolean>(true);
  // const [luckyName, setLuckyName] = useState<UserType>();
  const [list, setList] = useState<TUserOfLucky[]>([]);
  const [countdown, setCountdown] = useState(0);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const users = await LuckyDrawService(apiBaseUrl).findRandomLucky(id);
    const statusStart = await LuckyDrawService(apiBaseUrl).findById(id);
    setList(users);
    setStatusLucky(statusStart.status);
    setLoading(false);
  };

  //   const handleDrawClick = async () => {
  //     if (id) {
  //       await luckyDrawService.updateById(id, true);
  //       setStatusLucky(true);
  //     }
  //   };

  const handleStopClick = async () => {
    if (id) {
      await LuckyDrawService(apiBaseUrl).updateById(id, false);
      setStatusLucky(false);
    }
  };

  useEffect(() => {
    let timer: any;
    console.log(countdown)
    if (isRunning && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    } else if (countdown === 0 && isRunning) {
      endCountDown();
    }

    return () => clearInterval(timer);
  }, [countdown, isRunning]);

  const endCountDown = async () => {
    if (id) {
      await LuckyDrawService(apiBaseUrl).updateById(id, false);
      setStatusLucky(false);
      setIsRunning(false);
    }
  };

  const startCountdown = async () => {
    if (id) {
      const randomDuration = Math.floor(Math.random() * (10 - 5 + 1)) + 5;
      setCountdown(randomDuration);
      setIsRunning(true);
      await LuckyDrawService(apiBaseUrl).updateById(id, true);
      setStatusLucky(true);
    }
  };

  return loading ? (
    <Spin spinning={loading} />
  ) : (
    <>
      <div className="flex justify-center w-full">
        <Card className="w-full p-10 max-w-[50%]">
          <div className="text-center flex justify-center gap-4">
            {/* <div style={{ fontSize: "2.25rem", marginBottom: "1.25rem" }}>LUCKY DRAW</div> */}
            <Button size="large" onClick={startCountdown} loading={statusLucky} type="primary">
              START
            </Button>
            <Button size="large" onClick={handleStopClick} disabled={!statusLucky} type="primary">
              STOP
            </Button>
          </div>
        </Card>
      </div>
    </>
  );
};
